import React,{useState} from 'react';
import {Card,HTMLRenderer} from '../../components/';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {FormatDate} from '../../Utils/';
import {useHistory} from 'react-router-dom';
import {Button} from '../../components/';

const MyContents = ({tokenObject,connection}) => {

    const [Content,setContent] = useState([]);
    const [Category,setCategory] = useState("");
    const [wasAssigned,setWasAssigned] = useState(false);

    const [ContentSearch,setContentSearch] = useState("");

    const history = useHistory();

    function handleContentSearch(event){
        setContentSearch(event.target.value);
    }

    function SearchContent(){
        history.push('/Content?'+ContentSearch);
    }

    if(tokenObject.token === ""){
        return(
            <Redirect to="/login"/>
        );
    }

    (async function GetContents(){
        const result = await connection.get('/MyContents',{
            headers:{
                'user-access-token':tokenObject.token
            }
        });

        if(wasAssigned === false){
            setWasAssigned(true);

            let localContents = [];

            result.data.forEach((value,key) =>{
                localContents.push(value);
            });

            setContent(localContents);
        }
            
    })();

    return(
        <>
        <Card>
            <br/>
                <center><h1>My Contents</h1></center>
                <div className="mb-3">
                <select class="form-select" aria-label="Default select example" onChange={handleContentSearch}>
                    <option selected>Selecione um conteúdo</option>
                    {Content.map((value,index) => (
                                <option>{value.Title}</option>
                            ))}
                </select>
                    <br/>
                    <button className="btn btn-outline-primary" onClick={SearchContent}>Search</button>
                </div>
               
                

                <br/>
                <br/>
                {Content.map((value,index) => (
                    <Card key={index}>
                    <p>
                        <button className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target={"#collapseExample"+index} aria-expanded="false" aria-controls="collapseExample">
                            {value.Title}
                        </button>
                    </p>
                    <div className="collapse" id={"collapseExample"+index}>
                        <div className="card card-body" >
                            <HTMLRenderer Content={value.Content}/>
                            <Button type="secondary" isOutLine={true}>Update Content</Button>
                            <small className="text-muted">{FormatDate(value.Created_at)}</small>
                        </div>
                    </div>
                    <br/>
                    </Card>
                ))}
            <br/>
            {}
        </Card>
        </>
    )
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps)(MyContents);